/**
 * Ops console helpers. Spend never draws $0 for a null ledger.
 */
import { usd } from './format.ts';

export function spendFigure(usdAmount: number | null, entries: number): string {
  if (entries === 0) return 'none';
  if (usdAmount === null) return 'unknown';
  return usd(usdAmount);
}

export function spendNote(opts: {
  usd: number | null;
  entries: number;
  unknownEntries: number;
  attempts: number;
  window: string;
}): string {
  const { usd: amount, entries, unknownEntries, attempts, window } = opts;
  if (entries === 0) return `No ledger rows ${window}`;
  const priced = `${attempts} ${attempts === 1 ? 'attempt' : 'attempts'} ${window}`;
  if (amount === null) return `Cost unknown · ${priced}`;
  if (unknownEntries > 0) {
    return `${priced} · ${unknownEntries} ${unknownEntries === 1 ? 'entry' : 'entries'} unknown`;
  }
  return priced;
}

export function queueByStateNote(
  byState: readonly { state: string; count: number }[],
): string {
  if (byState.length === 0) return 'Nothing waiting for a runner';
  return byState.map((row) => `${row.count} ${row.state}`).join(', ');
}

/**
 * A first-pass rate as a percentage with its counts, so 1 of 1 never reads like 40 of 40.
 * No reviewed ticket in the window is "no data", not 0%.
 */
export function firstPassFigure(window: { firstPassed: number; firstReviewed: number; firstPassRate: number | null }): string {
  if (window.firstPassRate === null || window.firstReviewed === 0) return '—';
  return `${Math.round(window.firstPassRate * 100)}% (${window.firstPassed}/${window.firstReviewed})`;
}

/** Bounces per landed ticket to one decimal, with the counts behind it. */
export function bouncesFigure(window: { bounces: number; landed: number; bouncesPerLanded: number | null }): string {
  if (window.bouncesPerLanded === null || window.landed === 0) return '—';
  return `${window.bouncesPerLanded.toFixed(1)} (${window.bounces}/${window.landed})`;
}
